/* ShubVibes wishlist — localStorage, no account required.
   Powers: PDP "Save to Wishlist", product-card hearts, header count, /pages/wishlist grid. */
(function () {
  'use strict';
  var KEY = 'sv_wishlist_v1';

  function read() {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch (e) { return []; }
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('sv:wishlist:change'));
  }
  function has(id) { return read().some(function (x) { return String(x.id) === String(id); }); }
  function remove(id) { write(read().filter(function (x) { return String(x.id) !== String(id); })); }
  function add(item) {
    var list = read();
    if (list.some(function (x) { return String(x.id) === String(item.id); })) return;
    list.unshift(item);
    write(list);
  }
  function toggle(item) { if (has(item.id)) { remove(item.id); return false; } add(item); return true; }

  function itemFromBtn(btn) {
    return {
      id: btn.getAttribute('data-sv-wishlist'),
      title: btn.getAttribute('data-sv-wishlist-title') || '',
      url: btn.getAttribute('data-sv-wishlist-url') || '',
      image: btn.getAttribute('data-sv-wishlist-image') || '',
      price: btn.getAttribute('data-sv-wishlist-price') || ''
    };
  }

  function syncButton(btn) {
    var active = has(btn.getAttribute('data-sv-wishlist'));
    btn.setAttribute('aria-pressed', active ? 'true' : 'false');
    if (active) btn.setAttribute('data-sv-wishlist-active', '');
    else btn.removeAttribute('data-sv-wishlist-active');
    var label = btn.querySelector('[data-sv-wishlist-label]');
    if (label) {
      label.textContent = active
        ? (btn.getAttribute('data-sv-wishlist-active-label') || 'Saved to Wishlist')
        : (btn.getAttribute('data-sv-wishlist-idle-label') || 'Save to Wishlist');
    }
  }

  function updateCount() {
    var n = read().length;
    document.querySelectorAll('[data-sv-wishlist-count]').forEach(function (el) {
      var span = el.querySelector('span') || el;
      span.textContent = n;
      el.hidden = n === 0;
    });
  }

  function syncAll() {
    document.querySelectorAll('[data-sv-wishlist]').forEach(syncButton);
    updateCount();
  }

  function esc(s) { var d = document.createElement('div'); d.textContent = s == null ? '' : s; return d.innerHTML; }

  function renderGrid(grid) {
    var list = read();
    var empty = document.querySelector('[data-sv-wishlist-empty]');
    if (!list.length) {
      grid.innerHTML = '';
      grid.hidden = true;
      if (empty) empty.hidden = false;
      return;
    }
    if (empty) empty.hidden = true;
    grid.hidden = false;
    grid.innerHTML = list.map(function (x) {
      return '<div class="sv-card sv-wishlist-card">' +
        '<div class="sv-card__media">' +
          '<a href="' + esc(x.url) + '" class="sv-card__imglink" aria-label="' + esc(x.title) + '">' +
            (x.image ? '<img src="' + esc(x.image) + '" alt="' + esc(x.title) + '" loading="lazy" width="400" height="500">' : '') +
          '</a>' +
          '<button type="button" class="sv-wishlist-remove" data-sv-wishlist-remove="' + esc(x.id) + '" aria-label="Remove from wishlist">&times;</button>' +
        '</div>' +
        '<div class="sv-card__info">' +
          '<div><h3 class="sv-card__title"><a href="' + esc(x.url) + '">' + esc(x.title) + '</a></h3></div>' +
          '<span class="sv-price sv-card__price">' + esc(x.price) + '</span>' +
        '</div>' +
      '</div>';
    }).join('');
  }

  function boot() {
    syncAll();

    document.addEventListener('click', function (e) {
      var toggleBtn = e.target.closest('[data-sv-wishlist]');
      if (toggleBtn) {
        e.preventDefault();
        toggle(itemFromBtn(toggleBtn));
        var id = toggleBtn.getAttribute('data-sv-wishlist');
        document.querySelectorAll('[data-sv-wishlist="' + id + '"]').forEach(syncButton);
        updateCount();
        return;
      }
      var removeBtn = e.target.closest('[data-sv-wishlist-remove]');
      if (removeBtn) { e.preventDefault(); remove(removeBtn.getAttribute('data-sv-wishlist-remove')); }
    });

    var grid = document.querySelector('[data-sv-wishlist-grid]');
    if (grid) {
      renderGrid(grid);
      document.addEventListener('sv:wishlist:change', function () { renderGrid(grid); });
    }
    // Keep buttons/counts in sync across tabs and after any change.
    document.addEventListener('sv:wishlist:change', syncAll);
    window.addEventListener('storage', function (e) { if (e.key === KEY) syncAll(); });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
